import React from 'react';
import clsx from 'clsx';
import {IconButton, IconButtonProps as MUIIconButtonProps} from '@mui/material';
import './ArrIconButton.scss';
import ArrTooltip from '../arr-tooltip/ArrTooltip';

interface IconButtonProps extends MUIIconButtonProps {
  icon: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  ariaLabel: string;
  isToggled?: boolean;
  shape?: 'default' | 'none';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  className?: string;
  tooltipContent?: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  tooltipOffset?: number;
  tooltipTrigger?: 'hover' | 'click';
  showTooltipOnTruncate?: boolean;
  tooltipClassName?: string;
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
  testId: string;
  tooltipKey?: string;
  tooltipFocusableWrapper?: boolean;
}

const ArrIconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  ariaLabel,
  shape = 'default',
  disabled = false,
  size = 'medium',
  className,
  tooltipContent,
  tooltipPlacement = 'top',
  tooltipOffset = 0,
  tooltipTrigger = 'hover',
  showTooltipOnTruncate = false,
  tooltipClassName,
  testId = 'arr-icon-button',
  tooltipKey,
  tooltipFocusableWrapper = false,
  ...props
}) => {
  const classes = clsx(
    'icon-button',
    {
      'with-shape': shape === 'default',
    },
    className
  );

  const button = (
    <IconButton
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      className={classes}
      data-testid={testId}
      size={size}
      {...props}
    >
      {icon}
    </IconButton>
  );

  return tooltipContent ? (
    <ArrTooltip
      content={tooltipContent}
      trigger={tooltipTrigger}
      placement={tooltipPlacement}
      offset={tooltipOffset}
      isTruncated={showTooltipOnTruncate}
      showOnTruncate={showTooltipOnTruncate}
      className={tooltipClassName}
      tooltipKey={tooltipKey}
      labelId={`tooltip-${tooltipKey ?? tooltipContent}`}
      focusableWrapper={tooltipFocusableWrapper}
    >
      {button}
    </ArrTooltip>
  ) : (
    button
  );
};

export default ArrIconButton;
